import React from "react";
import { Link } from "react-router-dom";
import FadeInSection from "../FadeInSection";
import "./Mythology.css";

export default function MythologyHome() {
  return (
    <FadeInSection>
      <section className="hero-section" id="mythology-home">
        <div className="container">
          <h1 className="hero-name">mythology respawned</h1>
          <p className="hero-role">clas 160d2 · classical mythology</p>
          <p className="hero-bio">
            In Greco-Roman mythology, divine punishment often takes the form of transformation.
            Mortals who defy or deceive the gods lose their humanity and are reshaped into something lesser.
            Arachne boasted she surpassed Athena at weaving and was turned into a spider, condemned to spin forever.
            Echo aided Zeus in his deceits, lost her voice, and eventually her body; she was reduced to a sound bouncing off stone.
            Medusa was transformed by Athena's wrath into a monster whose gaze turned others to stone.
            This pattern runs through ancient literature and art from Hesiod to Ovid.
            This site traces that theme through ancient texts and artifacts, then follows it into an unexpected modern form:
            the character design of Overwatch, where the same ancient patterns appear in new shapes.
          </p>
          <div style={{ marginTop: "2rem", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            <Link to="/mythology/myths" className="myth-nav-link">
              myths →
            </Link>
            <Link to="/mythology/artifacts" className="myth-nav-link">
              artifacts →
            </Link>
            <Link to="/mythology/conclusions" className="myth-nav-link">
              conclusions →
            </Link>
            <Link to="/mythology/bibliography" className="myth-nav-link">
              bibliography →
            </Link>
          </div>
        </div>
      </section>
    </FadeInSection>
  );
}
